module.exports = __webpack_public_path__ + "static/media/otter.9e90fa36.svg";